import { render, staticRenderFns } from "./FollowupDueWarning.vue?vue&type=template&id=abf640ac&scoped=true"
import script from "./FollowupDueWarning.vue?vue&type=script&lang=js"
export * from "./FollowupDueWarning.vue?vue&type=script&lang=js"
import style0 from "./FollowupDueWarning.vue?vue&type=style&index=0&id=abf640ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf640ac",
  null
  
)

export default component.exports